// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PlC3kRaNQ7Dm4p4CYRb5{display:flex;align-items:center;gap:4px}.JqbIL7kd554D7TgLz4wY{color:var(--content-primary-primary);font-weight:500}`, "",{"version":3,"sources":["webpack://./src/shared/ui/TableNew/ui/DefaultHeaderCell/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,kBAAA,CACA,OAAA,CAEF,sBACE,oCAAA,CACA,eAAA","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n.activeNameSpan {\n  color: var(--content-primary-primary);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PlC3kRaNQ7Dm4p4CYRb5`,
	"activeNameSpan": `JqbIL7kd554D7TgLz4wY`
};
export default ___CSS_LOADER_EXPORT___;
